import { map, mapTo, mergeMap, catchError, tap, delay, filter, reduce } from 'rxjs/operators'
import { of } from 'rxjs'
import { ofType, combineEpics } from 'redux-observable'

import { WALLET_CREATE, WALLET_RESTORE, WALLET_STORAGE, WALLET_UNLOCK, PASSWORD_CHANGE } from '../../constants/actions'
import walletService from '../../services/wallet'
import storage from '../../services/storage'
import { logger } from '../../util/helpers'
import { RECEIVE_WALLET_NAV, BACKUP_WALLET_NAV } from '../../constants/navigation'
import history from '../../history'
import brandingService from '../../services/branding'

const handleCreateWallet = action$ => action$.pipe(
  ofType(WALLET_CREATE.ON_CREATE_WALLET),
  mergeMap(action => {
    return walletService.createWallet$().pipe(
      tap(wallet => logger(wallet)),
      tap(wallet => {
        if (wallet.address && wallet.mnemonic && wallet.privateKey) {
          history.replace(BACKUP_WALLET_NAV, { wallet, walletCreated: true })
        }
      }),
      map(wallet => storage.encryptAndStoreWallet(wallet, action.payload)),
      map(encryptedWallet => ({ type: WALLET_CREATE.ON_WALLET_CREATED, payload: encryptedWallet }))
    )
  })
)

const handleRestoreWallet = action$ => action$.pipe(
  ofType(WALLET_RESTORE.ON_RESTORE_WALLET),
  mergeMap(({ payload }) => {
    return walletService.restoreWallet$(payload.mnemonic).pipe(
      tap(wallet => logger(wallet)),
      map(wallet => storage.encryptAndStoreWallet(wallet, payload.password)),
      map(encryptedWallet => ({ type: WALLET_RESTORE.ON_WALLET_RESTORED, payload: encryptedWallet }))
    )
  })
)

const handleUnlockWallet = (action$, state$) => action$.pipe(
  ofType(WALLET_UNLOCK.ON_UNLOCK_WALLET),
  mergeMap(action => {
    const { walletProfile, unlockProfile } = state$.value.walletReducer
    const { wallet } = walletProfile
    const { password } = unlockProfile
    return walletService.unlockWallet$(wallet.encrypted, password).pipe(
      tap(wallet => logger(wallet)),
      tap(wallet => {
        if (wallet.address && wallet.mnemonic && wallet.privateKey) {
          const { history } = action.payload
          const { location } = history
          if (location && location.state && location.state.from) {
            history.replace(location.state.from, { wallet })
          } else {
            history.replace(RECEIVE_WALLET_NAV)
          }
        }
      }),
      map(_ => ({ type: WALLET_UNLOCK.ON_WALLET_UNLOCKED })),
      catchError(error => of({ type: WALLET_UNLOCK.ON_WALLET_UNLOCK_ERROR, payload: error }))
    )
  })
)

const handlePasswordChange = (action$, state$) => action$.pipe(
  ofType(PASSWORD_CHANGE.ON_PASSWORD_CHANGE_ACTION),
  mergeMap(action => {
    const { pwdChangeProfile } = state$.value.walletReducer
    const wallet = action.payload
    const { password } = pwdChangeProfile
    return walletService.setNewPassword$(wallet, password).pipe(
      mapTo({ type: PASSWORD_CHANGE.ON_PASSWORD_CHANGED_ACTION, payload: true }),
      catchError(error => of({ type: PASSWORD_CHANGE.ON_PASSWORD_CHANGE_ERROR, payload: error }))
    )
  })
)

const handleCheckStorage = action$ => action$.pipe(
  ofType(WALLET_STORAGE.ON_CHECK_STORAGE),
  mergeMap(() => of(storage.getWallet()).pipe(
    tap(wallet => logger(wallet)),
    delay(1),
    map(wallet => wallet ? ({ type: WALLET_STORAGE.ON_WALLET_FOUND, payload: wallet }) : ({ type: WALLET_STORAGE.ON_WALLET_NOT_FOUND }))
  ))
)

const handleWalletFound = action$ => action$.pipe(
  ofType(WALLET_STORAGE.ON_WALLET_FOUND),
  tap(_ => {
    const { pathname } = history.location
    if (pathname.indexOf('create') > -1) {
      history.replace(RECEIVE_WALLET_NAV)
    }
  }),
  filter(_ => false),
)

const handleWalletForBrands = (action$, state$) => action$.pipe(
  ofType(
    WALLET_STORAGE.ON_WALLET_FOUND,
    WALLET_CREATE.ON_WALLET_CREATED,
    WALLET_RESTORE.ON_WALLET_RESTORED
  ),
  filter(_ => extractBrandRedirect(state$)),
  tap(({ payload }) => {
    const redirect = extractBrandRedirect(state$)
    brandingService.redirectToBrand(redirect, payload.address)
  }),
  filter(_ => false),
)


export const walletEpic = combineEpics(
  handleCreateWallet,
  handleRestoreWallet,
  handleCheckStorage,
  handleUnlockWallet,
  handlePasswordChange,
  handleWalletFound,
  handleWalletForBrands
)

// Helpers
function extractBrandRedirect(state) {
  const { redirect } = state.value.authReducer.brandData
  return redirect
}


// WEBPACK FOOTER //
// ./src/store/epics/wallet.js